import { createSlice, createAction } from '@reduxjs/toolkit';

const initState = {
  calendar: [],
};

const CalendarSlice = createSlice({
  name: 'Calendar',
  initialState: initState,
  reducers: {
    getCalendarSteps(state, { payload }) {
      state.calendar = payload;
    },
  },
});

export const getCalendarStepsRequest = createAction(
  'eSign/get_calendar_steps_request',
);

export const { getCalendarSteps } = CalendarSlice.actions;

export default CalendarSlice;
